<template>
    <van-skeleton title :row="3"  :loading="skeLoading" style="margin-top: 20px">
        <div>
            <van-row class="dk-title" type="flex" align="center">
                <img src="@/assets/temperature_randis.png" alt="">
                <span style="font-weight: bold">客户信息</span>
            </van-row>
            <van-grid :column-num="2">
                <van-grid-item text="客户名称：" />
                <van-grid-item>
                    <!--客户选择-->
                    <span slot="text" @click="showPicker = true" class="dk-text">
                        {{customerShippingColumns[showPickerIndex]}}
                        <van-icon :name="showPicker ? 'arrow-up':'arrow-down'"/>
                    </span>
                </van-grid-item>
            </van-grid>

            <van-row class="dk-title" type="flex" align="center">
                <img src="@/assets/temperature_randis.png" alt="">
                <span style="font-weight: bold">实时库存</span>
            </van-row>
            <van-grid :column-num="3" v-for="(item,index) in model.listCustomerLeft" :key="'left_'+index">
                <van-grid-item>
                    <span slot="text" :class="item.isWarn ? 'dk-text-warn':'dk-text'" class="dk-text-center">
                        {{item.name}}
                        <br />
                        <span>
                            ({{item.number+item.priceUnit+'/'+item.numberUnit}})
                        </span>
                    </span>
                </van-grid-item>
                <van-grid-item>
                    <span slot="text" :class="item.isWarn ? 'dk-text-warn':'dk-text'">
                        {{item.packageNumber || item.packageNumber == 0 ? String(item.packageNumber) + item.numberUnit : '--'}}
                    </span>
                </van-grid-item>
                <van-grid-item>
                    <span slot="text" :class="item.isWarn ? 'dk-text-warn':'dk-text'">
                        {{item.value || item.value == 0 ? String(item.value) + item.priceUnit : '--'}}
                    </span>
                </van-grid-item>
            </van-grid>

            <van-row class="dk-title" type="flex" align="center">
                <img src="@/assets/temperature_randis.png" alt="">
                <span style="font-weight: bold">发货明细</span>
            </van-row>
            <van-list
                    v-model="listLoading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :error.sync="errored"
                    error-text="请求失败，点击重新加载"
                    :immediate-check="false"
                    @load="findStoreShippingList">
                <div v-for="(item, index) in shippingList" :key="'ss'+index">
                    <van-divider :class="item.orderType == 1 ? 'dk-title-divider-add' : item.orderType == 2 ? 'dk-title-divider-settle' : 'dk-title-divider'">
                        <van-icon name="lock" v-if="item.isLock"/>{{item.createTime ? (item.createTime.length>10?item.createTime.substr(0,10):item.createTime):''}}（{{item.orderNo}}#）{{item.orderType == 0 ? '发货': item.orderType == 1 ? '加购': item.orderType == 2 ? '结算':''}}
                    </van-divider>

                    <van-grid :column-num="2" :center="false" v-if="item.orderType == 0">
                        <van-grid-item>
                            <template slot="text">
                                <span class="dk-text dk-text-center">
                                    {{item.recipient}}
                                    <br />
                                    {{item.phone}}
                                </span>
                            </template>
                        </van-grid-item>
                        <van-grid-item :text="item.province + item.city + item.district + item.address"/>
                    </van-grid>
                    <van-grid :column-num="2" :center="false" v-if="item.orderType == 0" v-for="(logisticsCompany, logisticsRecordIndex) in item.storeLogisticsRecordList" :key="'arriveNo'+logisticsRecordIndex">
                        <van-grid-item>
                            <template slot="text">
                                <span class="dk-text">
                                    <van-badge dot :color="!logisticsCompany.state ? '#faad14' : logisticsCompany.state == 0 ? '#52c41a': logisticsCompany.state == 1 ? '#f5222d' : '#d9d9d9'"></van-badge>
                                    {{logisticsCompany.kdName}}
                                    <a @click="handleDetail(index, logisticsRecordIndex)" style="color: #1890FF">{{logisticsCompany.nu}}</a>
                                </span>
                            </template>
                        </van-grid-item>
                        <van-grid-item>
                            <template slot="text">
                                <template v-if="logisticsCompany.storeCustomerShippingCategory">
                                    <span class="dk-text" v-for="(shippingCategory, recordIndex) in logisticsCompany.storeCustomerShippingCategory.categoryNumberList" :key="'ssdd'+recordIndex">
                                        {{shippingCategory.name}}
                                        {{shippingCategory.packageNumber}}{{shippingCategory.numberUnit}}
                                        ({{shippingCategory.value}}{{shippingCategory.priceUnit}})
                                        <template v-if="recordIndex < (logisticsCompany.storeCustomerShippingCategory.categoryNumberList.length -1)">
                                            <br />
                                        </template>
                                    </span>
                                </template>
                            </template>
                        </van-grid-item>
                    </van-grid>
                    <van-grid :column-num="3" v-for="(categoryItem,index) in item.categoryNumberList" :key="'cata_'+index">
                        <van-grid-item>
                            <span slot="text" :class="item.orderType == 1 ? 'dk-text-warn': item.orderType == 2 ? 'dk-text-settle' : 'dk-text'" class="dk-text-center">
                                {{categoryItem.name}}
                                <br />
                                <span>
                                    ({{categoryItem.number+categoryItem.priceUnit+'/'+categoryItem.numberUnit}})
                                </span>
                            </span>
                        </van-grid-item>
                        <van-grid-item>
                             <span slot="text" :class="item.orderType == 1 ? 'dk-text-warn': item.orderType == 2 ? 'dk-text-settle' : 'dk-text'">
                                {{categoryItem.numberPackage || categoryItem.numberPackage == 0 ? String(categoryItem.numberPackage) + categoryItem.numberUnit : '--'}}
                            </span>
                        </van-grid-item>
                        <van-grid-item>
                            <span slot="text" :class="item.orderType == 1 ? 'dk-text-warn': item.orderType == 2 ? 'dk-text-settle' : 'dk-text'">
                                {{categoryItem.value || categoryItem.value == 0 ? String(categoryItem.value) + categoryItem.priceUnit : '--'}}
                            </span>
                        </van-grid-item>
                    </van-grid>
                </div>
            </van-list>

            <!--弹出框-->
            <van-dialog
                    v-model="showRecord"
                    title="物流信息"
                    show-cancel-button
                    :show-confirm-button="showConfirm"
                    cancel-button-text="关闭"
                    theme="round-button"
                    @cancel="closeRecord">
                <!--物流状态-->
                <van-row class="dk-record-title-state">
                    <van-badge dot color="#52c41a"></van-badge><span @click="changeState('0')">在途</span>
                    <van-badge dot color="#d9d9d9" style="margin-left: 8px"></van-badge><span @click="changeState('2')">签收</span>
                    <van-badge dot color="#faad14" style="margin-left: 8px"></van-badge><span @click="changeState()">未揽收</span>
                    <van-badge dot color="#f5222d" style="margin-left: 8px"></van-badge><span @click="changeState('1')">异常</span>
                </van-row>
                <van-row class="dk-record-title">
                    <span>
                        <van-badge dot :color="!logisticsCompanyRecord.state ? '#faad14' : logisticsCompanyRecord.state == 0 ? '#52c41a': logisticsCompanyRecord.state == 1 ? '#f5222d' : '#d9d9d9'"></van-badge>
                        {{logisticsCompanyRecord.kdName}}
                        {{logisticsCompanyRecord.nu}}
                    </span>
                </van-row>
                <!--产品信息-->
                <template v-if="logisticsCompanyRecord.storeCustomerShippingCategory">
                    <van-row class="dk-record-title-product">
                        <span v-for="(shippingCategory, recordIndex) in logisticsCompanyRecord.storeCustomerShippingCategory.categoryNumberList" :key="'ssdd'+recordIndex">
                            {{shippingCategory.name}}
                            {{shippingCategory.packageNumber}}{{shippingCategory.numberUnit}}
                            ({{shippingCategory.value}}{{shippingCategory.priceUnit}})
                            <template v-if="recordIndex < (logisticsCompanyRecord.storeCustomerShippingCategory.categoryNumberList.length -1)">
                                <br />
                            </template>
                        </span>
                    </van-row>
                </template>
                <!--物流记录-->
                <van-steps direction="vertical" :active="0" class="dk-record" v-if="logisticsRecord">
                    <van-step v-for="(item,index) in logisticsRecord.recordList" :key="'re'+index">
                        <van-tag slot="active-icon" round color="#f50" class="receipt" v-if="logisticsRecord.isCheck == 1 && index == 0">收</van-tag>
                        <p>{{item.status}}</p>
                        <p>{{item.time}}</p>
                        <p>{{item.context}}</p>
                    </van-step>
                </van-steps>
                <span v-else class="dk-record-text">暂无物流信息</span>
            </van-dialog>

            <!--弹出层-->
            <van-popup v-model="showPicker" round position="bottom">
                <van-picker
                        show-toolbar
                        title="选择客户"
                        :columns="customerShippingColumns"
                        @cancel="showPicker = false"
                        @confirm="onConfirm"
                />
            </van-popup>
        </div>
    </van-skeleton>
</template>

<script>
    import {Button, Col, Row, Calendar, Cell, CellGroup, Popup, Area, Field, Picker, Grid, GridItem,Divider,Checkbox, CheckboxGroup, Badge, Dialog, Step, Steps, Icon, Tag, Toast,Skeleton, List} from 'vant';
    import {getAction, postAction} from '@/api/manage'
    import {getStoreShippingReal, findStoreShippingList, getStoreRecord, getUserInfo, getUserOpenid, changeState} from '@/api/index'
    import {setStore, getStore} from "@/utils/storage";

    export default {
        name: "journey_detail",
        components: {
            [Button.name]: Button,
            [Col.name]: Col,
            [Row.name]: Row,
            [Calendar.name]: Calendar,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Area.name]: Area,
            [Popup.name]: Popup,
            [Field.name]: Field,
            [Picker.name]: Picker,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Divider.name]: Divider,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Badge.name]: Badge,
            [Dialog.Component.name]: Dialog.Component,
            [Step.name]: Step,
            [Steps.name]: Steps,
            [Icon.name]: Icon,
            [Tag.name]: Tag,
            [Skeleton.name]: Skeleton,
            [List.name]: List,
        },
        data() {
            return {
                appid: '',
                skeLoading: true,
                model:{},
                customerShippingList: [],
                customerShippingColumns: [],
                showPicker: false,
                showPickerIndex: 0,
                phone: '',
                showRecord: false,
                showConfirm: false,
                logisticsCompanyRecord: {},
                logisticsRecord: {},
                listLoading: false,
                finished: false,
                errored: false,
                shippingList: [],
                pageNo: 0,
                pageSize: 20
            }
        },
        created() {
            this.appid = this.$route.query.appid;
            console.log("appid====",this.appid);
            //微信授权判定
            if(this.appid) {
                if (getStore(this.appid + '_' + 'openid')) {
                    console.log("123",getStore(this.appid + '_' + 'openid'));
                    //获取用户信息
                    this.getUserInfo();
                }else{
                    console.log("微信授权");
                    this.getOpenId();
                }
            }
        },
        methods: {
            //微信授权
            getOpenId() {
                var access_code = this.getUrlParam('code');//通过获取code回调的链接中的response_type=code，来获取code
                console.log("code",access_code)
                if (access_code == "" || access_code == null) {
                    var fromurl = location.href;
                    var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+ this.appid
                        +"&redirect_uri=" + encodeURIComponent(fromurl)
                        +"&response_type=code"
                        +"&scope=snsapi_userinfo"
                        +"&state=STATE#wechat_redirect";
                    // location.href = url;
                    location.replace(url);
                }else {
                    //获取用户openid
                    postAction(getUserOpenid, {code: access_code, appid: this.appid}).then(res => {
                        if (res.success) {
                            Toast(res.message);
                            //授权成功，缓存用户信息，跳转相应页面
                            setStore(this.appid + '_' + 'openid', res.result.openid);
                            if(res.result.phone){
                                this.phone = res.result.phone;
                                setStore(this.appid + '_' + 'phone', res.result.phone);
                                this.getStoreShippingReal(this.phone);
                            }else{
                                this.$router.replace({name: 'noPhone'})
                            }
                        } else {
                            this.$router.replace({name: 'noPhone'})
                        }
                    }).catch(() => {
                        console.log("微信授权异常");
                    })
                }
            },
            getUrlParam(name){
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                } else {
                    return null;
                }
            },
            //获取用户信息
            getUserInfo(){
                getAction(getUserInfo, {openid: getStore(this.appid + '_' + 'openid'), appid: this.appid}).then(res => {
                    if (res.success) {
                        if(res.result.phone){
                            this.phone = res.result.phone;
                            setStore(this.appid + '_' + 'phone', res.result.phone);
                            this.getStoreShippingReal(this.phone);
                        } else {
                            this.$router.replace({name: 'noPhone'})
                        }
                    }else {
                        this.$router.replace({name: 'noPhone'})
                    }
                })
            },
            getStoreShippingReal(phone){
                getAction(getStoreShippingReal, {phone: phone}).then(res => {
                    if (res.success) {
                        if(res.result.length > 0){
                            this.customerShippingList = res.result;
                            //map结构处理
                            this.customerShippingColumns = this.customerShippingList.map((item) => {
                                return item.customerName;
                            });
                            this.model = res.result[0];
                            this.showPickerIndex = 0;
                            this.shippingList = [];
                            this.pageNo = 0;
                            this.findStoreShippingList();
                            setTimeout(() => {
                                this.skeLoading = false;
                            }, 300);
                        }else{
                            this.$router.replace({name: 'noPhone'})
                        }
                    }else{
                        Toast('暂无数据');
                    }
                })
            },
            findStoreShippingList(){
                var pageNo = this.pageNo + 1;
                getAction(findStoreShippingList, {customerId: this.model.customerId, pageNo: pageNo, pageSize: this.pageSize}).then(res => {
                    if (res.success) {
                        console.log("dfg",res.result);
                        if(res.result){
                            this.pageNo = res.result.current;
                            if(res.result.records.length != 0){
                                this.shippingList = this.shippingList.concat(res.result.records);
                            }
                            // 加载状态结束
                            this.listLoading = false;

                            // 数据全部加载完成
                            if (res.result.total == this.shippingList.length) {
                                this.finished = true;
                            }
                        }
                    }
                }).catch(() => {
                    this.errored = true;
                });
            },
            //index: 发货记录索引；logisticsRecordIndex：发货记录物流记录索引
            handleDetail(index, logisticsRecordIndex){
                this.logisticsCompanyRecord = this.shippingList[index].storeLogisticsRecordList[logisticsRecordIndex];
                this.logisticsRecord = {};
                this.getStoreRecord(this.logisticsCompanyRecord.shippingId,this.logisticsCompanyRecord.nu);
            },
            getStoreRecord(shippingId,arriveNo){
                getAction(getStoreRecord, {shippingId: shippingId, nu: arriveNo}).then(res => {
                    if (res.success) {
                        this.logisticsRecord = res.result;
                        this.showRecord = true;
                    } else {
                        Toast('暂无数据');
                    }
                })
            },
            closeRecord(){
                this.showRecord = false;
            },
            onConfirm(value, index){
                console.log(value,index);
                this.model = this.customerShippingList[index];
                this.showPickerIndex = index;
                this.shippingList = [];
                this.pageNo = 0;
                this.findStoreShippingList();
                this.showPicker = false;
            },
            //修改物流灯状态
            changeState(state){
                if(!this.logisticsRecord){
                    return;
                }
                Dialog.confirm({
                    title: '修改状态',
                    message: '是否修改物流状态为：' + (!state ? '未揽收': state == 0 ? '在途': state == 1 ? '异常':'签收'),
                })
                .then(() => {
                    // on confirm
                    let formData = {};
                    formData.id = this.logisticsRecord.id;
                    formData.state = state == 2 ? '3': state == 1 ? '2': state;
                    formData.isManual = 1;
                    postAction(changeState, formData).then(res => {
                        if (res.success) {
                            Toast(res.message);
                            this.logisticsCompanyRecord.state = state;
                        } else {
                            Toast(res.message);
                        }
                    }).catch(() => {
                        console.log("修改物流灯异常");
                    })
                })
                .catch(() => {
                    // on cancel
                });
            },
        }
    }
</script>

<style scoped>
    p{
        margin: 0.4em 0;
        font-size: 14px;
    }
    /deep/ .van-badge--dot{
        width: 10px;
        height: 10px;
    }
    /deep/ .van-dialog__header {
        padding-top: 0.4rem;
    }
    /deep/ .van-divider{
        margin: 0.15rem 0;
    }
    /deep/ .van-grid-item__content {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        flex-direction: column;
        box-sizing: border-box;
        height: 100%;
        padding: 0.32667rem 0.21333rem;
        background-color: #fff;
    }
    .dk-title {
        height: 49px;
        font-size: 16px;
        color: #333;
        background: #EEEEEE;
        padding: 0 15px;
    }
    .dk-title img {
        width: 4px;
        height: 16px;
        margin-right: 10px;
    }
    .dk-text {
        color: #646566;
        font-size: 0.32rem;
        line-height: 1.5;
        word-wrap: break-word;
    }
    .dk-text-warn{
        color: #D9001B;
        font-size: 0.32rem;
        line-height: 1.5;
        word-wrap: break-word;
    }
    .dk-text-settle{
        color: #4994df;
        font-size: 0.32rem;
        line-height: 1.5;
        word-wrap: break-word;
    }
    .dk-text-center{
        text-align: center;
    }
    .dk-record{
        height: 400px;
        overflow-y: auto;
    }
    .dk-record-title {
        display: flex;
        align-items: center;
        height: 28px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        padding: 0 0 0 0.85333em;
    }
    .dk-record-title-product {
        font-size: 0.28rem;
        color: rgba(0, 0, 0, 0.65);
        padding: 0 0 0 2.35333em;
    }
    .dk-record-title-state {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.85);
        padding: 0 0 0 0.85333em;
    }
    .dk-record-text {
        display: flex;
        align-items: center;
        height: 60px;
        font-size: 14px;
        color: #646566;
        padding: 0 0 0 1.85333em;
    }
    .dk-title-divider{
        padding: 0 15px;
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    .dk-title-divider-add{
        padding: 0 15px;
        font-size: 14px;
        font-weight: bold;
        color: #D9001B;
    }
    .dk-title-divider-settle{
        padding: 0 15px;
        font-size: 14px;
        font-weight: bold;
        color: #4994df;
    }
</style>
